import { ReleaseOfferRequestState } from './releaseOfferRequest.types'

const initialState: ReleaseOfferRequestState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
